import { Component } from '@angular/core';
import { LoginResponse } from './shared/models/user.models';
import { AuthenticationService } from './core/authentication/authentication.service';
import * as Sentry from '@sentry/angular-ivy';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'app';
  currentUser: LoginResponse;

  constructor(private authenticationService: AuthenticationService) {
    this.authenticationService.currentUser.subscribe((x) => {
      this.currentUser = x;

      // setup sentry context
      if (x) {
        Sentry.setUser({
          id: x.user.id,
          username: x.user.username,
          email: x.user.email,
        });
      }
    });
  }
}
